import { setupI18n } from '@lingui/core';
import { mergeCatalogs, sdkCatalog } from '@salsita-ai/platform-project-sdk/i18n';
import { messages as en } from './locales/en/messages.js';
export const catalog = {
    en
};
export const availableLocales = Object.keys(catalog);
const messages = mergeCatalogs([
    sdkCatalog,
    catalog
]);
export const createI18n = ()=>setupI18n({
        messages,
        locale: 'en'
    });

//# sourceMappingURL=index.js.map